import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { AbsencesRequestView, AbsencesView } from '@/modules/absences2'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/absences/absences-requests')({
  component: () => (
    <AbsencesView>
      <AbsencesRequestView />
    </AbsencesView>
  ),
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.absences', { ns: 'absences2' }),
      i18n.t('title.absences-request', { ns: 'absences2' })
    ])
})
